const hasAscendingSequenceOfThree = (value) => {
  const normalized = value.toLowerCase();
  const lastIndex = normalized.length - 2;

  for (let i = 0; i < lastIndex; i++) {
    const firstCharCode = normalized.charCodeAt(i);
    const secondCharCode = normalized.charCodeAt(i + 1);
    const thirdCharCode = normalized.charCodeAt(i + 2);

    const isSequential = secondCharCode === firstCharCode + 1 && thirdCharCode === secondCharCode + 1;

    if (isSequential) return true;
  }

  return false;
};

export const passwordRules = [
  { id: "hasMinLength", check: (password) => password.length >= 12 },
  { id: "hasLower", check: (password) => /[a-z]/.test(password) },
  { id: "hasUpper", check: (password) => /[A-Z]/.test(password) },
  { id: "hasNumber", check: (password) => /\d/.test(password) },
  { id: "hasSymbol", check: (password) => /[!@#$%^&*(),.?":{}|<>]/.test(password) },
  { id: "hasNoSequence", check: (password) => password.length > 3 && !hasAscendingSequenceOfThree(password) },
  { id: "hasNoRepeatedCharacters", check: (password) => password.length > 3 && !/(.)\1{2,}/.test(password) },
];

export const isPasswordStrong = (password) => passwordRules.every((rule) => rule.check(password || ""));
